import _ from "lodash";
import {getActionData} from "../_helpers";
import {visitedPageConstants} from "../_constants";
import {visitedPageService} from "../_services";
import {Auth} from "../components/Authorization";

function getVisitedPage(params) {
    return (dispatch) => {
        dispatch(getActionData(visitedPageConstants.GET_VISITED_PAGE_REQUEST));
        visitedPageService.getVisitedPage(params)
            .then(response => {
                dispatch(getActionData(visitedPageConstants.GET_VISITED_PAGE_SUCCESS, response.data));
            }).catch((error) => {
            if(_.get(error, 'response.status') === 401) {
                Auth.processLogout();
                return;
            }
            dispatch(getActionData(visitedPageConstants.GET_VISITED_PAGE_FAILURE, {}, error));
            console.error("Error fetching visited page: ", error);
        });
    }
}

function saveVisitedPage(payload) {
    return (dispatch) => {
        dispatch(getActionData(visitedPageConstants.SAVE_VISITED_PAGE_REQUEST));
        visitedPageService.saveVisitedPage(payload)
            .then(response => {
                dispatch(getActionData(visitedPageConstants.SAVE_VISITED_PAGE_SUCCESS, response.data));
            }).catch((error) => {
            if(_.get(error, 'response.status') === 401) {
                Auth.processLogout();
                return;
            }
            dispatch(getActionData(visitedPageConstants.SAVE_VISITED_PAGE_FAILURE, {}, error));
            console.error("Error saving visited page: ", error);
        });
    }
}

export const visitedPageActions = {
    getVisitedPage,
    saveVisitedPage
};